import { Component, OnInit, ElementRef, HostListener } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { CartService } from "../../services/cart.service";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  menuOpen = false;
  userMenuOpen = false;
  searchQuery = "";
  selectedCategory = "";
  cartItemCount = 0;
  cartTotalAmount = 0;
  isAuthenticated$ = new BehaviorSubject<boolean>(this.authService.isAuthenticated());

  categories = [
    'Ofertas Flash',
    'Tecnología',
    'Moda y Calzado',
    'Hogar y Confort',
    'Belleza',
    'Pago Contra Entrega'
  ];

  constructor(
    private router: Router,
    private authService: AuthService,
    private cartService: CartService,
    private eRef: ElementRef
  ) {
    this.authService.token$.subscribe(token => {
      this.isAuthenticated$.next(!!token);
    });
  }

  get currentUser(): any {
    const authUser = this.authService.getCurrentUser();
    if (authUser && (authUser.name || authUser.email)) {
      return authUser;
    }
    try {
      return JSON.parse(localStorage.getItem('user') || '{}');
    } catch {
      return {};
    }
  }

  get userName(): string {
    const user = this.currentUser;
    return user.name || user.fullName || user.nombre || (user.email ? user.email.split('@')[0] : 'Usuario Registrado');
  }

  get userEmail(): string {
    const user = this.currentUser;
    return user.email || 'Mi Cuenta Activa';
  }

  ngOnInit(): void {
    this.cartService.cart$.subscribe(items => {
      this.cartItemCount = items.reduce((acc, item) => acc + item.quantity, 0);
      this.cartTotalAmount = items.reduce((acc, item) => acc + ((item.product?.price || 0) * item.quantity), 0);
    });
  }

  onSearch(): void {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/shop'], { queryParams: { q: this.searchQuery, category: this.selectedCategory } });
    }
  }

  toggleUserMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.userMenuOpen = !this.userMenuOpen;
  }

  goToProfile(): void {
    this.userMenuOpen = false;
    this.router.navigate(['/profile']);
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (this.userMenuOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.userMenuOpen = false;
    }
  }

  logout() {
    this.userMenuOpen = false;
    this.cartService.clearCart();
    this.authService.logout();
    this.router.navigate(["/"]);
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
}
